"use strict";
// Please keep alphabetized
var IconType;
(function (IconType) {
    IconType[IconType["Default"] = 0] = "Default";
    IconType[IconType["Image"] = 1] = "Image";
})(IconType = exports.IconType || (exports.IconType = {}));

//# sourceMappingURL=IconType.js.map



//////////////////
// WEBPACK FOOTER
// ../components/Icon/IconType.js
// module id = 55
// module chunks = 0